import apiUrl from "../../Apiurl";

function isUrlAssolutaHttp(url) {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
  } catch (_error) {
    return false;
  }
}

export function risolviUrlDaAprire(url) {
  const urlString = String(url);
  return isUrlAssolutaHttp(urlString) ? urlString : apiUrl + urlString;
}

const apriUrl = function (url) {
  return window.open(risolviUrlDaAprire(url));
};

export default apriUrl;
